export default "__VITE_ASSET__udVhdZCT__"